import BaseEvent from './BaseEvent.js';

class SetLayerEvent extends BaseEvent {
  handle(msg) {
    this.context._api.setLayer(msg.params);
  }
}

export default SetLayerEvent;
